import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const Footer = () => {
  return (
    <footer className="bg-dark text-light py-5 mt-5" style={{ backgroundColor: '#212529 !important' }}>
      <Container>
        <Row>
          <Col md={4} className="mb-4">
            <h5 className="text-warning mb-3 fw-bold">
              <i className="fas fa-utensils me-2"></i>
              რესტორანი ატმოსფერო
            </h5>
            <p className="text-light mb-3">
              ჩვენ ვემსახურებით უმაღლესი ხარისხის ქართულ და ევროპულ კერძებს 
              მშვენიერი ატმოსფეროთი და მეგობრული მომსახურებით.
            </p>
          </Col>
          
          <Col md={4} className="mb-4">
            <h5 className="text-warning mb-3 fw-bold">
              <i className="fas fa-clock me-2"></i>
              საათები
            </h5>
            <div className="text-light">
              <p className="mb-2">
                <i className="fas fa-clock me-2 text-warning"></i> 
                ორშაბათი - პარასკევი: 11:00 - 23:00
              </p>
              <p className="mb-2">
                <i className="fas fa-clock me-2 text-warning"></i> 
                შაბათი - კვირა: 12:00 - 00:00
              </p>
            </div>
          </Col>
          
          <Col md={4} className="mb-4">
            <h5 className="text-warning mb-3 fw-bold">
              <i className="fas fa-phone me-2"></i>
              კონტაქტი
            </h5>
            <div className="text-light">
              <p className="mb-2">
                <i className="fas fa-phone me-2 text-warning"></i> 
                +995 555 123 456
              </p>
              <p className="mb-2">
                <i className="fas fa-envelope me-2 text-warning"></i> 
                info@atmosfero.ge
              </p>
              <p className="mb-2">
                <i className="fas fa-map-marker-alt me-2 text-warning"></i> 
                რუსთავის 15, თბილისი
              </p>
            </div>
          </Col>
        </Row>
        
        <hr className="my-4 border-light" />
        
        <Row>
          <Col md={6} className="text-center text-md-start">
            <p className="text-light mb-0">
              © 2025 რესტორანი ატმოსფერო. ყველა უფლება დაცულია.
            </p> 
          </Col>
          <Col md={6} className="text-center text-md-end">
            <div className="social-links">
              <a 
                href="https://facebook.com" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-light me-3 fs-5"
                title="Facebook"
              >
                <i className="fab fa-facebook"></i>
              </a>
              <a 
                href="https://instagram.com" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-light me-3 fs-5"
                title="Instagram"
              >
                <i className="fab fa-instagram"></i>
              </a>
              <a 
                href="https://twitter.com" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-light me-3 fs-5"
                title="Twitter"
              >
                <i className="fab fa-twitter"></i>
              </a>
            </div>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
